<template>
  <kst-table action input-mode :data="userItems">
    <b-table-column cell-class="ks-col-nopad" header-class="p-0" width="1">
      <template #header>
        <kst-header-blank />
      </template>
      <template #default="{ row }">
        <kst-tooltip v-if="row.Errors.length > 0" error-mode>
          <template #content>
            <kst-list :items="row.Errors"/>
          </template>
          <kst-icon error-mode/>
        </kst-tooltip>
      </template>
    </b-table-column>

    <b-table-column
      v-slot="{ column, row, index }"
      cell-class="k-control-py"
      field="Name"
      :label="HppAdjItemCatalog.Name.Label"
    >
      <kst-value error-off field-only
        class="k-control-py"
        :field="column.field" :data="row" :catalog="HppAdjItemCatalog"
        :index="index" @error="handleRowErrors"
      />
    </b-table-column>

    <b-table-column cell-class="ks-col-nopad" header-class="p-0" width="1">
      <template #header>
        <kst-header-blank />
      </template>
      <template #default="{ row }">
        <kst-tooltip info-mode>
          <template #content>
            <kst-list info-mode :items="Model.getItemInfo(row)"/>
          </template>
          <kst-icon info-mode/>
        </kst-tooltip>
      </template>
    </b-table-column>

    <b-table-column
      v-slot="{ column, row, index }"
      field="Stock"
      :label="HppAdjItemCatalog.Stock.Label"
    >
      <kst-input error-off field-only
        :field="column.field" :data="row" :catalog="HppAdjItemCatalog"
        :index="index" @error="handleRowErrors"
      />
    </b-table-column>

    <b-table-column
      v-slot="{ column, row, index }"
      field="HppPerPcs"
      :label="HppAdjItemCatalog.HppPerPcs.Label"
    >
      <kst-input error-off field-only
        :field="column.field" :data="row" :catalog="HppAdjItemCatalog"
        :index="index" @error="handleRowErrors" @input="handleHppTotal(row)"
      />
    </b-table-column>

    <b-table-column
      v-slot="{ column, row, index }"
      field="HppTotal"
      :label="HppAdjItemCatalog.HppTotal.Label"
    >
      <kst-output box-off field-only
        :index="index" :field="column.field" 
        :data="row" :catalog="HppAdjItemCatalog"
      />
    </b-table-column>

    <template #action="{ index }">
      <kst-tooltip delete-mode hover-only :content="Model.Item.Module.FullName">
        <kst-button delete-mode is-round @click="handleRowDelete(index)"/>
      </kst-tooltip>
    </template>

    <template #empty-body>
      <ValidationProvider v-slot="{ errors }" name="userItems" rules="required">
        <kst-error :array-blank-mode="!!errors"/>
      </ValidationProvider>
    </template>
  </kst-table>
</template>

<script>
import DialogMixin from "@/mixins/DialogMixin.js";
import Catalog from "../HppAdjCatalog.js";
import Info from "../HppAdjInfo.js";
import Model from "../HppAdjModel.js";
import HppAdjItemCatalog from "../HppAdjItemCatalog.js";

export default {
  mixins: [DialogMixin],
  props: {
    userItems: Array
  },
  data: () => ({
    Catalog: Catalog,
    Model: Model,
    HppAdjItemCatalog: HppAdjItemCatalog,
    selectedIndex: null
  }),
  methods: {
    handleHppTotal(item) {
      Model.updateItem(item);
    },

    handleRowDelete(index) {
      this.selectedIndex = index;
      this.showConfirm(
        Info.Message.New_ConfirmDeleteItem,
        this.handleRowDelete_Confirm,
        this.handleRowDelete_Cancel
      );
    },
    handleRowDelete_Confirm() {
      this.userItems.splice(this.selectedIndex, 1);

      this.selectedIndex = null;
    },
    handleRowDelete_Cancel() {
      this.selectedIndex = null;
    },
    handleRowErrors(errors, field, index) {
      Model.setItemErrors(this.userItems[index], field, errors);
    }
  }
}
</script>